import {Component, Prop, Emit, Watch, Vue} from 'vue-property-decorator';
import { WorkItem, BulkWorkItem, BulkUpdateWorkItemPram } from '@/types';

@Component({
    components: {
    }
})
export default class WorkItemBulkModal extends Vue {
    private bulkWorkItems: BulkWorkItem[] = [];
    private baseUrl = '/work_items';
    private workItemNames: string[] = [];
    private isDuplicateNameExists = false;

    @Prop()
    private workItems!: WorkItem[];

    @Prop()
    private withHidden!: boolean

    @Watch('workItems', { immediate: true })
    private convertWorkItemToBulkWorkItem() {
        this.bulkWorkItems = this.workItems.map((item) => {
            const convertedItem: BulkWorkItem = {
                id: item.id,
                name: item.name,
                update_type: 'UPDATE',
                is_hidden: item.is_hidden
            }
            return convertedItem;
        });

    }

    @Watch('bulkWorkItems', { deep: true})
    private bulkWorkItemsChange() {
         this.workItemNames = this.bulkWorkItems.map((item) => {
            return item.name;
         });
         this.isDuplicateNameExists = this.checkDuplicateNameExists(this.workItemNames);
    }

    private get duplicationNames() {
        return this.workItemNames.filter((val, idx, arr) => {
           return arr.indexOf(val) === idx && idx !== arr.lastIndexOf(val);
        });
    }

    private checkDuplicateNameExists(names: string[]) {
        const excludeBlankName = names.filter(name => name != '');
        return new Set(excludeBlankName).size !== excludeBlankName.length;
    }

    private addWorkItem() {
        const newOne: BulkWorkItem = {
            id: '',
            name: '',
            update_type: 'ADD',
            is_hidden: false
        }
        this.bulkWorkItems.push(newOne);
        this.$nextTick(() => {
            const element = this.$refs.rows as HTMLElement
            const bottom = element.scrollHeight - element.clientHeight;
            element.scrollTo(0, bottom)
        })
    }

    private submit() {
        const errmsg: string[] = []
        const workItems = this.bulkWorkItems.filter((item, index) => {
            if(item.name && item.name.length > 100) {
                errmsg.push(`項目${index+1}: 作業名は100文字以内で入力してください（現在は${item.name.length}文字）`)
            }
            return !!item.name
        })
        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        const bulkUpdateItems: BulkUpdateWorkItemPram = {
            work_items : workItems
        };
        this.$apiClient.doRequest('put', `${this.baseUrl}/bulk_update`, bulkUpdateItems).then(() => {
            this.$toasted.success('変更を保存しました。')
            this.submitEnd();
            this.closeModal()
        }).catch(() => {
            this.$toasted.error('変更に失敗しました。')
        });
    }

    @Emit('submitEnd')
    private submitEnd() {
        return this.withHidden;
    }

    @Emit('closeModal')
    private closeModal() {
        this.convertWorkItemToBulkWorkItem();
    }
}